module.exports = __webpack_public_path__ + "img/Icon_Legal_Proceeds.98566d04.svg";